import { ApplicationController } from "../application_controller";

// First level tabs of a card (the deal) on phones and tablets: one row that scrolls sideways and sticks under
// the header, the active tab is scrolled to the middle, and the "All sections" button at the right edge opens
// the list of all the tabs as a bottom sheet. Put it next to layout--tabs on the ul.nav. The tab links,
// their ids and BSN.Tab stay as they are, so the content still loads on the link click
// (layout--load-activate-element-id). A tab can be for one layout only: data-mobile-hidden on its item hides
// it on phones and tablets (neither in the strip nor in the sheet), .d-lg-none shows it there only.
export default class extends ApplicationController {
  connect() {
    this.element.classList.add("tabs-strip");
    // the strip scrolls sideways on purpose (bin/mobile-check)
    this.element.setAttribute("data-mobile-check-scroll-ok", "");
    this.addAllSectionsButton();

    this.onShown = event => this.centerTab(event.target);
    this.element.addEventListener("shown.bs.tab", this.onShown);
    // a turned tablet must not stay on a tab the new layout does not show
    this.stopLayoutWatch = this.onMobileLayoutChange(() => this.leaveHiddenTab());
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.tab", this.onShown);
    if (this.stopLayoutWatch) this.stopLayoutWatch();
    this.closeSheet();
    if (this.allItem) this.allItem.remove();
  }

  // the tabs the current layout shows
  links() {
    return Array.from(this.element.querySelectorAll(":scope > .nav-item > .nav-link[href^='#']"))
      .filter(link => getComputedStyle(link.parentElement).display !== "none");
  }

  leaveHiddenTab() {
    const active = this.element.querySelector(":scope > .nav-item > .nav-link.active");
    if (!active || getComputedStyle(active.parentElement).display !== "none") return;

    const first = this.links()[0];
    if (first) first.click();
  }

  centerTab(link) {
    if (!this.isMobileLayout || !link || !link.scrollIntoView) return;
    link.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
  }

  addAllSectionsButton() {
    this.allItem = document.createElement("li");
    this.allItem.className = "nav-item tabs-strip__all d-lg-none";
    const button = document.createElement("button");
    button.type = "button";
    // not a .nav-link: BSN.Tab looks for the tabs by that class
    button.className = "tabs-strip__all-button";
    button.title = document.body.dataset.mobileAllSections;
    button.setAttribute("aria-label", document.body.dataset.mobileAllSections);
    button.setAttribute("aria-haspopup", "true");
    button.setAttribute("aria-expanded", "false");
    button.innerHTML = "<i class='fas fa-ellipsis-h'></i>";
    button.addEventListener("click", () => this.openSheet());
    this.allButton = button;
    this.allItem.appendChild(button);
    this.element.appendChild(this.allItem);
  }

  // the list of all the tabs; a tap opens the tab through its own link. A phone gets a sheet at the bottom, in
  // reach of the thumb; a tablet gets a menu under the button: on a tall screen a sheet would be far from it
  openSheet() {
    this.closeSheet();
    this.sheet = document.createElement("div");
    this.sheet.className = "mobile-sheet";
    this.sheet.innerHTML = "<div class='mobile-sheet__backdrop'></div>" +
      "<div class='mobile-sheet__panel' role='menu'><div class='mobile-sheet__title'></div></div>";
    this.sheet.querySelector(".mobile-sheet__title").textContent = document.body.dataset.mobileAllSections;
    const panel = this.sheet.querySelector(".mobile-sheet__panel");

    this.links().forEach(link => {
      const item = document.createElement("button");
      item.type = "button";
      item.className = "mobile-sheet__item" + (link.classList.contains("active") ? " is-active" : "");
      item.setAttribute("role", "menuitem");
      item.textContent = link.textContent.trim();
      item.addEventListener("click", () => {
        this.closeSheet();
        link.click();
        this.centerTab(link);
      });
      panel.appendChild(item);
    });

    this.sheet.querySelector(".mobile-sheet__backdrop").addEventListener("click", () => this.closeSheet());
    this.onKeydown = event => { if (event.key === "Escape") this.closeSheet(); };
    document.addEventListener("keydown", this.onKeydown);
    document.body.appendChild(this.sheet);
    if (this.isTabletLayout) this.placeUnderButton(panel);
    document.body.classList.add("mobile-sheet--open");
    this.allButton.setAttribute("aria-expanded", "true");
  }

  placeUnderButton(panel) {
    const button = this.allButton.getBoundingClientRect();
    const top = Math.round(button.bottom + 4);
    this.sheet.classList.add("mobile-sheet--menu");
    panel.style.top = `${top}px`;
    panel.style.right = `${Math.round(window.innerWidth - button.right)}px`;
    panel.style.maxHeight = `${Math.max(200, window.innerHeight - top - 16)}px`;
  }

  closeSheet() {
    if (!this.sheet) return;
    this.sheet.remove();
    this.sheet = null;
    document.body.classList.remove("mobile-sheet--open");
    document.removeEventListener("keydown", this.onKeydown);
    if (this.allButton) this.allButton.setAttribute("aria-expanded", "false");
  }
}
